var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 29,
    viewBox: "0 0 11 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C8.46875 0 10.811 2.52418 10.5893 5.48464L9.65348 17.981C9.49071 20.1546 7.67967 21.8351 5.5 21.8351C3.32033 21.8351 1.50929 20.1546 1.34652 17.981L0.410721 5.48464C0.189025 2.52417 2.53125 0 5.5 0ZM6.18064 23.1964C7.78326 23.1964 9.08243 24.4956 9.08243 26.0982C9.08243 27.7008 7.78326 29 6.18064 29H4.81936C3.21674 29 1.91757 27.7008 1.91757 26.0982C1.91757 24.4956 3.21675 23.1964 4.81936 23.1964H6.18064Z",
    fill: "url(#paint0_linear_6384_34751)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6384_34751",
    x1: -1.84861,
    y1: 60.175,
    x2: -17.9308,
    y2: 55.0305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamMark);
export default __webpack_public_path__ + "static/media/exclam_mark.5ab3ef27dceecdc4898183984af29b6d.svg";
export { ForwardRef as ReactComponent };